import { crossSVG } from "../constants";

interface BoxProps {
	text?: string;
	uuid: string;
	parentSituation: string;
	role: string;
	removeReferent: (
		situationId: string,
		role: string,
		referentId: string
	) => void;
}

export function Box(props: BoxProps) {
	return (
		<div>
			<p>{props.text}</p>
			<div
			className="close"
				onClick={() => {
					props.removeReferent(
						props.parentSituation,
						props.role,
						props.uuid
					);
				}}>{crossSVG}</div>
		</div>
	);
}
